import { Fragment } from "react";
import { Stack } from "@/core/components/ui/stack";
import { DROPPED, WORD } from "@/payroll/editor/diff-marks";
import type { EnrichedRosterMember } from "@/payroll/editor/types";

const SIDES = [
  { key: "before", label: "Before: ", mark: DROPPED },
  { key: "after", label: "After: ", mark: WORD.added },
] as const;

export const TeamsCol = ({ member }: { member: EnrichedRosterMember }) => {
  const change = member.teamChange;
  return (
    <td className="w-56 min-w-40 max-w-64 whitespace-normal break-words py-1 pr-3">
      {change ? (
        <Stack gap="xs">
          {SIDES.map((side) => (
            <span key={side.key}>
              <span className="text-sm text-tertiary-text">{side.label}</span>
              {change[side.key].length
                ? change[side.key].map((team, index) => (
                    <Fragment key={team.id}>
                      {index > 0 && ", "}
                      {team.changed ? (
                        <mark className={side.mark}>{team.name}</mark>
                      ) : (
                        <span className="text-secondary-text">{team.name}</span>
                      )}
                    </Fragment>
                  ))
                : "No team"}
            </span>
          ))}
        </Stack>
      ) : (
        <span className="text-secondary-text">{member.teamNames}</span>
      )}
    </td>
  );
};
